import { Avatar, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { GreenInvoiceIcon, TrashBin } from 'Images';
import { DeleteButtons } from './DeleteButtons';
import { format } from 'date-fns';
import { shorterDateFormat } from 'Config';
import { IInvoice } from 'Context/CannabisContext';

interface IDeleteModal {
  closeModal: () => void;
  invoice: IInvoice;
  onClickYes: () => void;
}

export const DeleteDialog = ({
  closeModal,
  invoice: { invoiceId, invoiceDate, invoiceTotal },
  onClickYes,
}: IDeleteModal) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Reimbursements);
  const isDesktop = useIsDesktop();

  return (
    <Stack alignItems={'center'} p={'72px 25px 48px'} gap={'24px'}>
      <Avatar
        alt=''
        src={TrashBin}
        sx={
          isDesktop
            ? { width: '159.25px', height: '142px' }
            : { width: '120px', height: '107px' }
        }
      />
      <Typography
        component={'h1'}
        sx={
          isDesktop
            ? { fontSize: '24px', fontWeight: 600, lineHeight: '31px' }
            : { fontSize: '20px', fontWeight: 600, lineHeight: '24px' }
        }
      >
        {dictionary.deleteInvoice}
      </Typography>
      <Stack
        sx={{
          p: '20px 16px',
          bgcolor: 'white',
          borderRadius: '12px',
          gap: '16px',
        }}
      >
        <Stack direction={'row'} gap='20px' alignItems='center'>
          <Avatar
            alt=''
            src={GreenInvoiceIcon}
            sx={{ width: '56px', height: '56px' }}
          />
          <Stack
            direction={isDesktop ? 'row' : 'column'}
            gap={isDesktop ? '48px' : '4px'}
          >
            <Stack
              alignItems='flex-start'
              gap={isDesktop ? undefined : '4px'}
              direction={isDesktop ? 'column' : 'row'}
              width='fit-content'
            >
              <Typography variant={isDesktop ? 'body6' : 'body3'}>{`${
                dictionary.number
              }${isDesktop ? '' : ':'}`}</Typography>
              <Typography variant={isDesktop ? 'body2' : 'body3'}>
                {invoiceId}
              </Typography>
            </Stack>
            <Stack
              alignItems='flex-start'
              gap={isDesktop ? undefined : '4px'}
              direction={isDesktop ? 'column' : 'row'}
              width='fit-content'
            >
              <Typography variant={isDesktop ? 'body6' : 'body3'}>{`${
                dictionary.date
              }${isDesktop ? '' : ':'}`}</Typography>
              <Typography variant={isDesktop ? 'body2' : 'body3'}>
                {invoiceDate && format(invoiceDate, shorterDateFormat)}
              </Typography>
            </Stack>
            <Stack
              alignItems='flex-start'
              gap={isDesktop ? undefined : '4px'}
              direction={isDesktop ? 'column' : 'row'}
              width='fit-content'
            >
              <Typography variant={isDesktop ? 'body6' : 'body1'}>{`${
                dictionary.amount
              }${isDesktop ? '' : ':'}`}</Typography>
              <Typography variant={isDesktop ? 'body2' : 'body1'}>
                {`₪${invoiceTotal?.toLocaleString()}`}
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
      <DeleteButtons
        noLabel={dictionary.no}
        yesLabel={dictionary.yesDelete}
        onClickNo={closeModal}
        onClickYes={onClickYes}
      />
    </Stack>
  );
};
